/**
 * The one seeded generator the view uses, in one place.
 *
 * Everything the site animates is a function of chain data: the burn-moment
 * particles are seeded so a replay looks identical, and the neurons a block makes
 * blink are picked from that block's hash. Neither is random at runtime, and both
 * need the same generator to stay that way.
 */

export function mulberry32(seed: number): () => number {
  let state = seed;

  return () => {
    state = (state + 0x6d2b79f5) | 0;

    let mixed = Math.imul(state ^ (state >>> 15), 1 | state);

    mixed = (mixed + Math.imul(mixed ^ (mixed >>> 7), 61 | mixed)) ^ mixed;

    return ((mixed ^ (mixed >>> 14)) >>> 0) / 4_294_967_296;
  };
}
